import React from 'react';
import PropTypes from 'prop-types';

import TagsAutocompleteInput from 'components/TagsAutocompleteInput';
import FormError from '../FormError';
import FormGroup from '../FormGroup';
import FormLabel from '../FormLabel';

const FormGroupTags = ({
  input,
  label,
  placeholder,
  isDisabled,
  meta: { touched, error, active },
  className,
  inputProps,
  ...restProps
}) => {
  const getValueArray = () => (!Array.isArray(input.value) ? [] : input.value);

  return (
    <FormGroup
      active={active}
      className={className}
      error={error}
      touched={touched}
    >
      {label && <FormLabel htmlFor={input.name}>{label}</FormLabel>}
      <TagsAutocompleteInput
        onlyUnique
        inputProps={{ ...inputProps, placeholder, 'data-test': 'tag-input' }}
        isDisabled={isDisabled}
        tagProps={{
          'data-test': 'tagInput-tag',
        }}
        value={getValueArray()}
        onChange={input.onChange}
        {...restProps}
      />

      {touched && error && <FormError>{error}</FormError>}
    </FormGroup>
  );
};

FormGroupTags.propTypes = {
  className: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    ),
    onChange: PropTypes.func,
  }),
  inputProps: PropTypes.shape({
    isLoading: PropTypes.bool,
  }),
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  meta: PropTypes.shape({
    active: PropTypes.bool,
    error: PropTypes.string,
    touched: PropTypes.bool,
  }),
  placeholder: PropTypes.string,
};

FormGroupTags.defaultProps = {
  isDisabled: false,
  inputProps: { isLoading: false },
  input: {
    name: '',
    value: [],
  },
  label: '',
  meta: {
    touched: false,
    error: '',
  },
};

export default FormGroupTags;
